import React from "react";
import '../components/PackageSection.css';
import { Link } from "react-router-dom";
import {PackageCard} from '../components/PackageCard.js';
import './TopPlace.css';
import mukafall from "../media/tourism/Mukha fall/fall1.jpeg";
import dubai from "../media/dubai.jpg";
import europe from "../media/europebg.jpg";
import fossils from "../media/tourism/Fossils Park/fossils1.jpeg";
import rock from "../media/tourism/Canvas Rock Painting/rock1.jpg";
import Shiva from "../media/tourism/Shiv Dwar/shiv1.jpg";
import vijayfort from "../media/tourism/Vijaygarh Fort/fort2.jpg";
import dam from "../media/tourism/Rihand Dam/dam3.jpeg";

const TopPlace = () => {

  const packageInfoRow1 = [
    {
      place: "Mukha Fall",
      info: "Scenic beauty of river belan falling from a height of 100 ft",
      img: mukafall,
      price: "4000-5000 INR",
      placename: "mukhafall",
    },
    {
      place: "Rihand Dam",
      info: "Largest dam of India by volume",
      img: dam,
      price: "4000-5000 INR",
      placename: "rihanddam",
    },
    {
      place: "Fossils Park",
      info: "Asia's oldest and Over 150 Crore year old fossils park",
      img: fossils,
      price: "4000-5000 INR",
      placename: "fossilspark",
    },
    {
      place: "ShivDwar Temple",
      info: "11th Century Temple of Lord Shiva and Goddess Parvati",
      img: Shiva,
      price: "4000-5000 INR",
      placename: "shivdwartemple",
    },
    {
      place: "Vijaygarh Fort",
      info: "Built at time of Mahabharata and still alive",
      img: vijayfort,
      price: "4000-5000 INR",
      placename: "vijaygarhfort",
    },
    {
      place: "Cave Paintings",
      info: "Over 4000 years old Rock paintings, showing culture",
      img: rock,
      price: "4000-5000 INR",
      placename: "cavepaintings",
    },
  ];
  //const packageInfoRow2 = [
    // {
    //   place: "dubai",
    //   info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Praesentium repellat repudiandae iste veritatis cumque vitae!",
    //   img: dubai,
    //   price: "4000-5000 INR",
    // },
    // {
    //   place: "europe",
    //   info: "Lorem ipsum dolor sit amet consectetur adipisicing elit.Praesentium repellat repudiandae iste veritatis cumque vitae!",
    //   img: europe,
    //   price: "4000-5000 INR",
    // },
    
  //];
  return (
    <> <div className="topplace-wrapper">
      <div className="container3">
        <section className="packages" id="packages">
          <div className="outerbox">
            <h1>
              Top Places
              <hr />
            </h1>
            <p>
          Below is list of Top Places to visit in Sonbhadra, We offer our services for all the mentioned locations. Embark on an unforgettable adventure journey of sonbhadra, India's hidden gem, by Sonbhadra tourism.
          Explore ancient temples, cascading waterfalls, breathtaking wildlife sanctuaries, and rich tribal culture. 
          Discover the perfect blend of history, adventure, science and natural beauty.
        </p>
            <div className="row1">
              {packageInfoRow1.map((element) => {
                return (
                  <PackageCard
                    placeName={element.place}
                    img={element.img}
                    info={element.info}
                    // price={element.price}
                    location={element.place}
                    locationname={element.placename}
                  />
                );
              })}
            </div>
            {/* <h2>
              International
              <hr />
            </h2>
            <div className="row2">
              {packageInfoRow2.map((element) => {
                return (
                  <PackageCard
                    placeName={element.place}
                    img={element.img}
                    info={element.info}
                    price={element.price}
                    location={element.place}
                  />
                );
              })}
            </div> */}
            <div className="morebtn">
              <Link to="/locations">
                <button className="more-btn">Explore all</button>
              </Link>
            </div>
          </div>
        </section>
      </div>
      </div>
    </>
    
  );
};

export default TopPlace;
